import { SQL_INSTANCE_NAME_HINT, SQL_INSTANCE_QUESTION, mainInstanceNote } from '@/data/sqlInstance'
import { effectiveServerMode, useInfrastructureWizard } from '@/stores/infrastructureWizard'
import { dbNameStyle, resolveServerName, takenInstanceNames, validateSqlInstanceName } from '@/utils/infraValidation'
import page from '@/pages/NewDeploymentPage.module.css'
import styles from './Infrastructure.module.css'
import { TextField } from './TextField'
import { YesNoQuestion } from './YesNoQuestion'

/**
 * "Do you need an ODBC connection / new SQL instance?", asked once for every product, level and DB server choice. Yes: the customer
 * gets a dedicated SQL instance, named here (checked against the server's instances where they are fetched). No: the field is
 * cleared, and the server's main instance is used.
 */
export function SqlInstanceQuestion() {
  const data = useInfrastructureWizard()
  const { sqlInstance, setSqlInstanceRequired, setSqlInstanceName } = data
  const mode = effectiveServerMode(data.product, data.dbServer.mode, 'db')
  if (!data.level) return null

  let serverName = 'the DB server'
  if (mode === 'existing' && data.dbServer.existing) serverName = data.dbServer.existing.name
  if (mode === 'dedicated') {
    const resolved = resolveServerName(data, 'db', dbNameStyle(data.level))
    if (resolved.ok) serverName = resolved.name
  }
  const name = sqlInstance.instanceName

  return (
    <section className={styles.section} aria-label="SQL instance">
      <YesNoQuestion question={SQL_INSTANCE_QUESTION} name="sql-instance-required" value={sqlInstance.required} onChange={setSqlInstanceRequired} />
      {sqlInstance.required === true && (
        <div className={page.formGrid}>
          <TextField
            id="sql-instance-name"
            label="SQL instance name"
            required
            value={name}
            onChange={setSqlInstanceName}
            problem={name.trim() === '' ? null : validateSqlInstanceName(name, takenInstanceNames(data))}
            hint={SQL_INSTANCE_NAME_HINT}
          />
        </div>
      )}
      {sqlInstance.required === false && (
        <p className={styles.note} data-testid="main-instance-note">
          {mainInstanceNote(serverName)}
        </p>
      )}
    </section>
  )
}
